
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

const { update } = require('lodash');

require('./bootstrap');

$(function(){
    var next_url = $('.continue a').attr("href");

    $('.input-in').trigger('keyup');

    // START
    $(".continue-in a").on('click', function () {
        var local_authority = parseFloat($('.local_authority').val()) || 0;
        if($('.government').val() != 'other') {
            var government = parseFloat($('.government').val()) || 0;
            var government_other = 0;
        } else {
            var government = $('.government').val();
            var government_other = parseFloat($('[name="government_other"]').val() || 0);
        }
        var disability_selected = $('select.disability').multipleSelect('getSelects');
        var disability = disability_selected.reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        var job = parseFloat($('.job').val()) || 0;

        local_authority = local_authority.toFixed(2);

        if($('.government').val() != 'other') {
            government = government.toFixed(2);
            government_other = government_other.toFixed(2);
        } else {
            government_other = government_other.toFixed(2);
        }

        disability = disability.toFixed(2);
        job = job.toFixed(2);

        var spending_url = next_url + '?local_authority='+ local_authority+'&government=' + government  + '&government_other=' + government_other + '&disability=' + disability + '&disability_selected=' + disability_selected + '&job=' + job;
        $('.continue a').attr("href", spending_url);

    });

    // SPENDING
    $(".input-spent").on('keyup', function () {
        var bills = 0;
        $('.bills').each(function(){
            bills += parseFloat($(this).val()) || 0;
        });

        var essentials = 0;
        $('.essentials').each(function(){
            essentials += parseFloat($(this).val()) || 0;
        });

        var fun = 0;
        $('.fun').each(function(){
            fun += parseFloat($(this).val()) || 0;
        });

        var savings = 0;
        $('.savings').each(function(){
            savings += parseFloat($(this).val()) || 0;
        });

        var total = parseFloat(bills) + parseFloat(essentials) + parseFloat(fun) + parseFloat(savings);

        var percent = 0;
        var current = 0;

        if (total <= maxSpend){
            percent = (total / maxSpend) * 100;
            current = total;
        } else {
            percent = 100;
            current = maxSpend - total;
        }
        var summary_url = next_url + '&bills=' + bills  + '&essentials=' + essentials + '&fun=' + fun + '&savings=' + savings;
        $('.progress .bg-danger').css('width', percent + '%');
        $('.progress .bg-success').css('width', 100 - percent + '%');
        $('.progress-spent').text(total.toFixed(2));
        $('.progress-diff').text((maxSpend-total).toFixed(2));
        $('.progress-current').text(current.toFixed(2));
        $('.continue a').attr("href", summary_url);

        if (maxSpend-total < 0) {
            $('.green-circle').addClass('red-circle');
            $('.green-circle').addClass('fa-times-circle');
            $('.green-circle').removeClass('fa-check-circle');
        } else {
            $('.green-circle').removeClass('red-circle');
            $('.green-circle').removeClass('fa-times-circle');
            $('.green-circle').addClass('fa-check-circle');
        }
        
    });

    $('.section-continue a').on('click', function(e){
        if($('#sections > div:last-child').is(":hidden")){
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".progress").offset().top-20
            }, 500);
            var index = $('#sections > div:visible').index();
            UIkit.tab('.sub-group').show(index+1);
            e.preventDefault()
        }
    });

    $('.multiple-select').multipleSelect({
        selectAll: true,
        displayValues: true,
        dropWidth: 500,
        width: 80,
    });

    $('.single-select').multipleSelect({
        selectAll: false,
        single: true,
        dropWidth: 450,
        width: 80,
    });

    function updateSelects(select) {
        let name = select.attr('name');

        if(select.val() == 'other') {
            $('[name="' + name + '_other"').parent().show();
        } else {
            $('[name="' + name + '_other"').parent().hide();
        }
    }

    if($('select.single-select')) {
        updateSelects($('select.single-select'));
    }

    $('select.single-select').on('change', function() {
        updateSelects($(this));
    });

});
